import CleanInterior from './asset/clean-interior.svg'
import EasyTransit from './asset/easy-transit.svg'
import GoodNeighborhood from './asset/good-neighborhood.svg'
import GoodPrice from './asset/good-price.svg'
import KindHost from './asset/kind-host.svg'
import ManyAmenities from './asset/many-amenities.svg'
import NiceInterior from './asset/nice-interior.svg'
import QuickResponse from './asset/quick-response.svg'

export const ILLUST = {
  cleanInterior: CleanInterior,
  easyTransit: EasyTransit,
  goodNeighborhood: GoodNeighborhood,
  goodPrice: GoodPrice,
  kindHost: KindHost,
  manyAmenities: ManyAmenities,
  niceInterior: NiceInterior,
  quickResponse: QuickResponse,
}

export type IllustName = keyof typeof ILLUST
